import { parseISODate } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  APPLICATION_PLANS,
  ApplicationPlan,
  COLLEGE_TIERS,
  CollegeTier,
  UserCollege,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

const STRINGS = appStrings.modules.myColleges;

const TIER_GROUPS: readonly (CollegeTier | null)[] = [...COLLEGE_TIERS, null];

/** Formats a `YYYY-MM-DD` date as that same calendar day in the viewer's timezone. */
const formatDeadline = (date: string | null) =>
  date
    ? parseISODate(date).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
      })
    : STRINGS.noDeadline;

export const groupByTier = (colleges: readonly UserCollege[]) =>
  TIER_GROUPS.map((tier) => ({
    tier,
    colleges: colleges.filter((college) => college.tier === tier),
  })).filter((group) => group.colleges.length > 0);

const isRollingDeadline = (college: UserCollege) =>
  Boolean(college.rolling_admission) &&
  (college.application_plan === null || college.application_plan === 'rolling');

export const hasDeadline = (college: UserCollege) =>
  isRollingDeadline(college) || college.my_deadline !== null;

export const deadlineText = (college: UserCollege) =>
  isRollingDeadline(college) ? STRINGS.rolling : formatDeadline(college.my_deadline);

const isPlanOffered = (plan: ApplicationPlan, college: UserCollege) => {
  switch (plan) {
    case 'ed':
      return college.early_decision !== false;
    case 'ea':
      return college.early_action !== false && college.early_action_restrictive !== true;
    case 'rea':
      return college.early_action !== false && college.early_action_restrictive !== false;
    case 'rolling':
      return college.rolling_admission !== false;
    case 'rd':
      return true;
  }
};

export const offeredPlans = (college: UserCollege) =>
  APPLICATION_PLANS.filter(
    (plan) => plan === college.application_plan || isPlanOffered(plan, college),
  );

export const canOpenAwardLetter = (college: UserCollege) =>
  college.has_award_letter || college.status === 'accepted' || college.status === 'enrolled';
